<script setup>
import { useCartStore } from '@/stores/cart';
import { useUserStore } from '@/stores/userStore';
import CIcon from '@coreui/icons-vue';
import {cilBell} from '@coreui/icons'
import eventBus from '@/utils/eventBus';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
const userStore = useUserStore();
const cartStore = useCartStore();
const tabs = [
    'Personal Details',
    'Billing Address',
    'Contact Details',
    'Email Details',
    'PAN Details',
    'Bank Details',
    'PC to Consultant',
    'FSSAI Details',
    'My Addresses'
];
const fssai = computed(()=>userStore.getuserfssai);
const panId = computed(()=>userStore.getuserPan);
const type = computed(()=>userStore.getuserType);
function changeTab(tab) {
    router.push({ path: "/app/profile", query: { section: tab } });
    if (eventBus.panelClose) {
        eventBus.panelClose();
    }
}
function logout() {
    userStore.destroySession();
    cartStore.clearCart();
    window.location.href='/';
    cartStore.destroyCart();
    console.log('logged out')
}
function openModal(tab){
    if (eventBus.panelOpen) {
      eventBus.panelOpen(tab);
    }
}
</script>
<template>

    <div class="col-md-12 col-0">
        <!-- Tabs -->
        <div class="tabs-desktop">
            <div class="sidebar">
                <ul class="menu">
                    <li>
                        <span>
                        <CIcon :icon="cilBell" size="sm" style="height:10px"/>
                            Notifications
                        </span>
                    </li>
                    <li @click="openModal('Notifications')">
                       <span> See Notifications</span>
                       >
                    </li>
                </ul>    
                <ul class="menu">
                    <li>
                        <span style="display: flex;">
                            <span style="display: none;" class="svg_logo">
                                <svg width="13" height="15" viewBox="0 0 10 12" version="1.1" aria-hidden="true"
                                    fill="currentColor" focusable="false" xmlns="http://www.w3.org/2000/svg">
                                    <g stroke="none" stroke-width="1" fill-rule="evenodd">
                                        <path
                                            d="M4.86768 6.66675C6.52393 6.66675 7.86768 5.323 7.86768 3.66675C7.86768 2.0105 6.52393 0.666748 4.86768 0.666748C3.21143 0.666748 1.86768 2.0105 1.86768 3.66675C1.86768 5.323 3.21143 6.66675 4.86768 6.66675ZM6.04104 7.13607C6.26845 7.06411 6.47092 7.00005 6.73304 7.00005C8.27887 7.00005 9.53304 8.25422 9.53304 9.80005V10.3334C9.53304 10.8855 9.08512 11.3334 8.53304 11.3334H1.19971C0.647624 11.3334 0.199707 10.8855 0.199707 10.3334V9.80005C0.199707 8.25422 1.45387 7.00005 2.99971 7.00005C3.263 7.00005 3.46571 7.06424 3.69323 7.13628C3.98419 7.22841 4.31572 7.33338 4.86637 7.33338C5.41745 7.33338 5.74972 7.22825 6.04104 7.13607ZM1.19971 9.80005V10.3334H8.53304V9.80005C8.53304 8.80838 7.72471 8.00005 6.73304 8.00005C6.62653 8.00005 6.49861 8.04037 6.33174 8.09296L6.33173 8.09296C6.01879 8.19159 5.56887 8.33338 4.86637 8.33338C4.16943 8.33338 3.717 8.19163 3.40222 8.09301C3.23428 8.04039 3.10552 8.00005 2.99971 8.00005C2.00804 8.00005 1.19971 8.80838 1.19971 9.80005ZM6.86768 3.66675C6.86768 2.56466 5.96976 1.66675 4.86768 1.66675C3.76559 1.66675 2.86768 2.56466 2.86768 3.66675C2.86768 4.76883 3.76559 5.66675 4.86768 5.66675C5.96976 5.66675 6.86768 4.76883 6.86768 3.66675Z"
                                            fill="#2C2C2C">
                                        </path>
                                    </g>
                                </svg>
                                
                            </span>
                            Account
                        </span>
                    </li>
                    <template v-for="(tab, index) in tabs" :key="index">
                        <li @click="changeTab(tab)"  v-if="type==1 && !(
                            (type == 0 ||( tab == 'PAN Details' && panId)) ||  
                            (type == 0 && tab === 'Bank Details') ||          // Hide if type is 0 and it's Bank Details
                            (type == 0 || (tab == 'FSSAI Details' && fssai)) ||
                            (type == 1 && tab === 'PC to Consultant')         // Hide if type is 1 and it's PC to Consultant
                            )" 
                            :class="{ active: activeTab === tab }">

                            <span class="">{{ tab }}</span>>
                        </li>
                        <li @click="changeTab(tab)"  v-if="type==0 && !(
                            (type == 0 && tab === 'PAN Details') ||  // Hide if type is 0 and panId is available
                            (type == 0 && tab === 'Bank Details') ||          // Hide if type is 0 and it's Bank Details
                            (type == 0 && tab === 'FSSAI Details')  // Hide if type is 0 and fssai is available
                            )" 
                            :class="{ active: activeTab === tab }">

                            <span class="">{{ tab }}</span>>
                        </li>
                    </template>
                </ul>
                <ul class="menu">
                    <li>
                        <span style="display: flex;">
                            <span class="svg_logo">
                                <svg width="15" height="17" viewBox="0 0 10 12" version="1.1" aria-hidden="true"
                                    fill="currentColor" focusable="false" xmlns="http://www.w3.org/2000/svg">
                                    <g stroke="none" stroke-width="1" fill-rule="evenodd">
                                        <path
                                            d="M7.78141 1.16818L8.72876 0.486514C9.16651 0.172905 9.7567 0.493047 9.7567 1.01355V10.8639C9.7567 11.3909 9.15998 11.698 8.72876 11.3888L7.78141 10.7071L6.94076 11.3125C6.57488 11.5761 6.08487 11.5761 5.719 11.3125L4.87835 10.7071L4.03771 11.3125C3.66965 11.5761 3.18182 11.5761 2.81594 11.3125L1.9753 10.7071L1.02794 11.3909C0.590193 11.7045 0 11.3822 0 10.8639V1.01355C0 0.484336 0.596727 0.177261 1.02794 0.486514L1.9753 1.16818L2.81594 0.562738C3.18057 0.299223 3.67308 0.299223 4.03771 0.562738L4.87835 1.16818L5.719 0.562738C6.08705 0.29922 6.57488 0.29922 6.94076 0.562738L7.78141 1.16818ZM2.26459 6.6344H7.4914C7.58722 6.6344 7.66562 6.7128 7.66562 6.80863V7.50553C7.66562 7.60136 7.58722 7.67976 7.4914 7.67976H2.26459C2.16877 7.67976 2.09036 7.60136 2.09036 7.50553V6.80863C2.09036 6.7128 2.16877 6.6344 2.26459 6.6344ZM8.71225 10.0862L7.78232 9.41762L6.3297 10.463L4.87709 9.41762L3.42447 10.463L1.97185 9.41762L1.04627 10.0862V1.78866L1.97621 2.45726L3.42883 1.4119L4.88144 2.45726L6.33406 1.4119L7.78667 2.45726L8.71225 1.78866V10.0862ZM2.26459 4.19519H7.4914C7.58722 4.19519 7.66562 4.27359 7.66562 4.36941V5.06632C7.66562 5.16215 7.58722 5.24055 7.4914 5.24055H2.26459C2.16877 5.24055 2.09036 5.16215 2.09036 5.06632V4.36941C2.09036 4.27359 2.16877 4.19519 2.26459 4.19519Z"
                                            fill="#2C2C2C"></path>
                                    </g>
                                </svg>
                            </span>
                            <span>Orders</span>
                        </span>
                    </li>
                    <li @click="changeTab('Order History')">
                       <span> Order History</span>
                       >
                    </li>
                </ul>
            </div>

        </div>
    </div>
    <a @click="logout" class="close_icon full-width" style="margin: 0;max-width: 91%;">
        <span class="full-width">
            <svg width="12" height="12" viewBox="0 0 12 12" version="1.1" aria-hidden="true"
                fill="currentColor" focusable="false" xmlns="http://www.w3.org/2000/svg">
                <g stroke="none" stroke-width="1" fill-rule="evenodd">
                    <path
                        d="M1.83333 0C0.826742 0 0 0.826742 0 1.83333V10.1667C0 11.1733 0.826742 12 1.83333 12H7.83333C8.83992 12 9.66667 11.1733 9.66667 10.1667C9.6676 10.1004 9.65536 10.0346 9.63066 9.97314C9.60595 9.91166 9.56927 9.8557 9.52275 9.80852C9.47622 9.76133 9.42079 9.72386 9.35966 9.69829C9.29853 9.67272 9.23293 9.65955 9.16667 9.65955C9.1004 9.65955 9.0348 9.67272 8.97367 9.69829C8.91255 9.72386 8.85711 9.76133 8.81059 9.80852C8.76406 9.8557 8.72738 9.91166 8.70268 9.97314C8.67797 10.0346 8.66573 10.1004 8.66667 10.1667C8.66667 10.6327 8.29941 11 7.83333 11H1.83333C1.36726 11 1 10.6327 1 10.1667V1.83333C1 1.36726 1.36726 1 1.83333 1H7.83333C8.29941 1 8.66667 1.36726 8.66667 1.83333C8.66573 1.89959 8.67797 1.96537 8.70268 2.02685C8.72738 2.08834 8.76406 2.1443 8.81059 2.19148C8.85711 2.23867 8.91255 2.27614 8.97367 2.30171C9.0348 2.32729 9.1004 2.34045 9.16667 2.34045C9.23293 2.34045 9.29853 2.32729 9.35966 2.30171C9.42079 2.27614 9.47622 2.23867 9.52275 2.19148C9.56927 2.1443 9.60595 2.08834 9.63066 2.02685C9.65536 1.96537 9.6676 1.89959 9.66667 1.83333C9.66667 0.826742 8.83992 0 7.83333 0H1.83333ZM9.16146 3.16146C9.06195 3.16148 8.96471 3.19119 8.88219 3.24679C8.79966 3.30239 8.7356 3.38134 8.6982 3.47356C8.6608 3.56577 8.65176 3.66704 8.67223 3.76442C8.69271 3.86179 8.74178 3.95085 8.81315 4.02018L10.293 5.5H3.16667C3.10041 5.49906 3.03463 5.5113 2.97315 5.53601C2.91166 5.56072 2.8557 5.5974 2.80852 5.64392C2.76133 5.69044 2.72386 5.74588 2.69829 5.80701C2.67272 5.86814 2.65955 5.93374 2.65955 6C2.65955 6.06626 2.67272 6.13186 2.69829 6.19299C2.72386 6.25412 2.76133 6.30956 2.80852 6.35608C2.8557 6.4026 2.91166 6.43928 2.97315 6.46399C3.03463 6.4887 3.10041 6.50094 3.16667 6.5H10.293L8.81315 7.97982C8.76517 8.02589 8.72686 8.08107 8.70046 8.14214C8.67407 8.2032 8.66013 8.26892 8.65945 8.33544C8.65878 8.40196 8.67138 8.46794 8.69653 8.52953C8.72167 8.59112 8.75885 8.64707 8.80589 8.69411C8.85293 8.74115 8.90888 8.77833 8.97047 8.80347C9.03206 8.82862 9.09804 8.84122 9.16456 8.84055C9.23108 8.83987 9.2968 8.82593 9.35786 8.79954C9.41893 8.77315 9.47411 8.73483 9.52018 8.68685L11.8535 6.35352C11.9472 6.25974 11.9999 6.13259 11.9999 6C11.9999 5.86741 11.9472 5.74026 11.8535 5.64648L9.52018 3.31315C9.47358 3.26516 9.41781 3.227 9.3562 3.20094C9.29458 3.17489 9.22836 3.16146 9.16146 3.16146Z"
                        fill="#000">
                    </path>
                </g>
            </svg>
            Logout
        </span>
    </a>
</template>
<style scoped>
.menu li {
    text-decoration: none;
    color: black;
    padding: 8px 15px 8px 25px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    text-align: left;
    display: flex;
    justify-content: space-between;
}

.menu {
    list-style: none;
    padding: 0;
    margin: 0;
    border-bottom: 1px dotted #cbcbcb;
    padding: 0;
    padding-bottom: 15px;
    padding-top: 10px;
}





.menu li:hover {
    background-color: #f1f2ff;
    margin-left: 0;
}

.menu li:first-child {
    padding: 8px 0px;
    display: flex !important;
    font-weight: 900;
}

.menu li:first-child:hover {
    background-color: unset;
}

.menu li:first-child .svg_logo {
    display: flex !important;
    margin-right: 10px;
    align-content: center;
    flex-wrap: wrap;
}

.close_icon {
    display: flex;
    position: absolute !important;
    bottom: 10px;
    width: 100%;
    align-items: center;
    background-color: white;
    justify-content: center;
}

.close_icon > span {
    display: flex;
    justify-content: center;
    gap: 10px;
    /* background-color: #2c2c2c; */
    background-color: #006ea5;
    border-radius: 10px;
    color: #fff;
    height: 45px;
    width: 150px;
    align-items: center;
    cursor: pointer;
    user-select: none;
}
.close_icon svg {
    width: 20px;
    height: 20px;
}
.close_icon path{
    fill: white;
}

</style>
<style>
.card-content{
    padding: 0 20px 30px!important;
}
</style>